// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Tk9zM","title":"styles_title__2TsrA"};